const BRAND_NAME_PATH = '/app/static/images/brand/brand-name-dark.svg';
const LOGO_PATH = '/app/static/images/brand/logo-light.svg';
const HEADER_LOGO_WIDTH_PX = 103;
const WATERMARK_WIDTH_PX = 720;
const WATERMARK_OPACITY = 0.2;
const HEADER_LOGO_MARGIN_BOTTOM_PX = 24;

export const getBrandedPdfContent = (
  baseUrl: string,
  content: string
): string => {
  const brandNamePath = `${baseUrl}${BRAND_NAME_PATH}`;
  const logoPath = `${baseUrl}${LOGO_PATH}`;

  const headerLogoHtml = `<div style="margin-bottom: ${HEADER_LOGO_MARGIN_BOTTOM_PX}px;"><img src="${brandNamePath}" alt="Company logo" style="width: ${HEADER_LOGO_WIDTH_PX}px; height: auto;" /></div>`;

  const watermarkHtml = `<div class="pdf-watermark" aria-hidden="true" style="position: fixed; top: 0; left: 0; right: 0; bottom: 0; display: flex; align-items: center; justify-content: center; pointer-events: none; z-index: 10;"><img src="${logoPath}" alt="" role="presentation" style="width: ${WATERMARK_WIDTH_PX}px; height: auto; opacity: ${WATERMARK_OPACITY}; transform: rotate(-45deg);" /></div>`;

  return `${watermarkHtml}${headerLogoHtml}<div style="position: relative; z-index: 1;">${content}</div>`;
};

export const PDF_WATERMARK_PRINT_CSS = `
  .pdf-watermark {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;
